import React from 'react'

import Event from './Event'
import EventsLoader, { useEvents } from './_load/EventsLoader'
import FlexGrid from '../../../../components/structure/FlexGrid'
import Text from '../../../../packages/kiti/components/presentation/Text'
import BulkEditableReply from '../../../../containers/replies/BulkEditableReply'
import LineSeparator from '../../../../packages/kiti/components/helpers/LineSeparator'

const EventsList = () => {
  const events = useEvents()
  return (
    <FlexGrid gutter={0.3} direction="column" align="stretch">
      <Text>{'Use o campo abaixo para alterar a resposta de todas as perguntas.'}</Text>
      <BulkEditableReply events={events} />
      <LineSeparator />
      {events.map(item => (
        <Event key={item.id} item={item} startsOpen={true} />
      ))}
    </FlexGrid>
  )
}

const Wrapper = () => {
  return (
    <EventsLoader>
      <EventsList />
    </EventsLoader>
  )
}

export default Wrapper
